import { Grid } from '@mui/material';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router';
import StepWizard from 'react-step-wizard';
import {
  Layout,
  Loading,
  ReturnButton,
  TranslucentContainer,
  UserNavbar,
} from '../../../components';
import { getEventById } from '../../../core/events/action';
import {
  findVendorEventRegistered,
  setVendorEventPayload,
  resetVendorEventState,
} from '../../../core/vendor-events/action';
import { getFeaturesByVenueId } from '../../../core/venues/action';
import Charges from './components/Charges';
import InfoEventCard from './components/InfoEventCard';
import Preferences from './components/Preferences';
import VendorInformation from './components/VendorInformation';
import Payment from './components/Payment';
import SuccessPage from './components/Success';
import { APPLICATION_STATUS, PAYMENT_STATUS } from '../../../constants/event-application-status';
import WaitApprovalPage from './components/WaitApproval';
import PaymentPage from './components/PaymentPage';
import DeniedPage from './components/DeniedPage';
import CancelledPage from './components/CancelledPage';
import { getSystemParameters } from '../../../core/system-parameters/action';
import { APP_ROUTES } from '../../../constants/app-routes';

export default function EventRegistration() {
  const { id: eventId } = useParams();
  const {
    events: { event, loading },
    users: { user },
    vendorEvents: { currentVendorEvent, loading: vendorEventsLoading },
  } = useSelector((store) => store);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getSystemParameters());
    dispatch(resetVendorEventState());
    dispatch(getEventById(eventId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (event?.id && user?.id) {
      dispatch(getFeaturesByVenueId(event.fk_venue));
      dispatch(findVendorEventRegistered(user.id, event.id));
      dispatch(setVendorEventPayload({ fk_vendor: user.id, fk_event: event.id, state: true }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, event?.id, user?.id]);

  const render = () => {
    if (currentVendorEvent.has_been_cancelled) {
      return <CancelledPage />;
    }

    if (currentVendorEvent?.status === PAYMENT_STATUS.PAID) {
      return <SuccessPage />;
    }

    switch (currentVendorEvent?.application_status) {
      case APPLICATION_STATUS.APPROVED:
        return <PaymentPage />;
      case APPLICATION_STATUS.PENDING:
        return <WaitApprovalPage />;
      case APPLICATION_STATUS.DENIED:
        return <DeniedPage />;
      default:
        return (
          <StepWizard>
            <VendorInformation />
            <Preferences />
            <Charges />
            <Payment />
          </StepWizard>
        );
    }
  };

  return (
    <Layout>
      {loading || vendorEventsLoading ? <Loading /> : null}
      <UserNavbar />
      <Grid container marginTop={9} marginLeft={4}>
        <Grid item xs={12} lg={8}>
          <ReturnButton path={APP_ROUTES.DASHBOARD} />
        </Grid>
      </Grid>

      <Grid container justifyContent="center">
        <TranslucentContainer>
          <Grid container justifyContent="center" marginBottom={2}>
            <Grid item xs={12} lg={8}>
              <InfoEventCard event={event} />
            </Grid>
          </Grid>
          <Grid container justifyContent="center" marginBottom={2}>
            <Grid item xs={12} lg={8}>
              {render()}
            </Grid>
          </Grid>
        </TranslucentContainer>
      </Grid>
    </Layout>
  );
}
